import { api } from '@api'
import { FetchParams, PaginatedResponse } from './types'
import { usePaginate } from './usePaginate'
import { Contact } from './types/contactTypes'

const fetchColorLabelContacts = async ({ pageParam = '1', id }: FetchParams): Promise<PaginatedResponse<Contact>> => {
  const url = `/color-labels/${id}/contacts?page=${pageParam}`
  const { data } = await api.get<PaginatedResponse<Contact>>(url)
  return data
}

export const usePaginateColorLabelContacts = (id: string) => {
  return usePaginate<Contact>('color-label-contacts', fetchColorLabelContacts, { id }, { enabled: !!id })
}
